import type { Address } from "viem"

/**
 * Pending Classic LP creation: user has submitted create-pool tx and we are waiting
 * for the pool to appear in the Task Sync API.
 */
export interface PendingClassicLpCreate {
  kind: "classic-lp"
  pairAddress: Address
  token0Symbol: string
  token1Symbol: string
  chainId: number
  createdAt: number
}

/**
 * Pending Gauge creation: user has submitted create-gauge tx and we are waiting
 * for the gauge to appear in the API with a valid displayName.
 */
export interface PendingGaugeCreate {
  kind: "gauge"
  gaugeAddress: Address
  pairAddress: Address
  pairDisplayName: string
  chainId: number
  createdAt: number
}

export type PendingCreation = PendingClassicLpCreate | PendingGaugeCreate

export function isPendingClassicLp(p: PendingCreation): p is PendingClassicLpCreate {
  return p.kind === "classic-lp"
}

export function isPendingGauge(p: PendingCreation): p is PendingGaugeCreate {
  return p.kind === "gauge"
}
